import React from "react";
import {Modal} from "antd";
import {useTranslation} from "react-i18next";
import {
    ModalContainer,
    ConfirmationText,
    CancelButton,
    ConfirmButton,
    ModalStyle,
    ModalBodyStyle,
    ConfirmationButtonContainer
} from "./CourierRequestConfirmationModal.styles";

const CourierDecreaseConfirmationModal = ({
    visible,
    onCancel,
    onConfirm,
    courierCount,
    loading = false
}) => {
    const {t} = useTranslation();

    const getConfirmationText = () => {
        if (!courierCount) return "";

        return t("screens.customerRequests.decreaseConfirmationText", {
            count: courierCount
        });
    };

    return (
        <Modal
            title={null}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            centered
            closable={true}
            width={400}
            style={ModalStyle}
            bodyStyle={ModalBodyStyle}
        >
            <ModalContainer>
                <ConfirmationText>{getConfirmationText()}</ConfirmationText>
                <ConfirmationButtonContainer>
                    <CancelButton onClick={onCancel} disabled={loading}>
                        {t("screens.customerRequests.no")}
                    </CancelButton>
                    <ConfirmButton onClick={onConfirm} disabled={loading}>
                        {loading
                            ? t("screens.customerRequests.loading")
                            : t("screens.customerRequests.yes")}
                    </ConfirmButton>
                </ConfirmationButtonContainer>
            </ModalContainer>
        </Modal>
    );
};

export default CourierDecreaseConfirmationModal;
